export default {
      id: "play-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.b0d228b5.svg#play",
      toString: function () {
        return this.url;
      }
    }